export const CostCalculator = {
  // Operation costs for single credits bucket
  OPERATION_COSTS: {
    search: 10,
    verify: 5,
    enrichment: 2
  },
  UNIFIED_CREDITS_BASE: 10,

  VALID_OPERATIONS: ['search', 'verify', 'enrichment'],

  calculate(operation, quantity = 1, singleCreditsBucket = true) {
    if (!this.VALID_OPERATIONS.includes(operation)) {
      throw new Error(`Invalid operation: ${operation}`);
    }

    return singleCreditsBucket
      ? this.OPERATION_COSTS[operation] * quantity
      : quantity;
  },

  calculateVisualRepresentation(operation, quantity = 1, singleCreditsBucket = true) {
    if (!this.VALID_OPERATIONS.includes(operation)) {
      throw new Error(`Invalid operation: ${operation}`);
    }

    return singleCreditsBucket ? this.OPERATION_COSTS[operation] * quantity / 10.0 : quantity;
  }
};
